import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import "@babel/polyfill";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "./styles/main.css";


import 'vuetify/dist/vuetify.min.css'

Vue.config.productionTip = false;

import VueI18n from "vue-i18n";
import { languages } from "./shared/languages";
Vue.use(VueI18n);
const messages = Object.assign(languages);
let lan = "en";
try {
  if (localStorage.getItem("MTGAPPLan") == 'fr')
   lan = "fr";
} catch (err) {
  console.error(err);
}
var i18n = new VueI18n({
  locale: lan,
  fallbackLocale: "en",
  messages
});

import currency from "v-currency-field";
import DatetimePicker from 'vuetify-datetime-picker'
//import "v-currency-field/dist/index.css";
Vue.use(currency);
Vue.use(DatetimePicker)

const HelloJs = require("hellojs/dist/hello.all.min.js");
const VueHello = require("vue-hellojs");
Vue.use(VueHello, HelloJs);


import jquery from 'jquery';
window.$ = jquery;

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)


import 'alertifyjs/build/alertify.min.js'
import 'alertifyjs/build/css/alertify.min.css'
import 'alertifyjs/build/css/themes/bootstrap.min.css'
import Alertifyjs from 'vue2-alertifyjs'
const opts = {
  notifier:{
      delay:1      
  }
}

Vue.use(Alertifyjs,opts)

Vue.mixin({
  data() {
    return {
      theme: {
        themeIdx: null,
        dark: false
      }
    };
  }
});
 

// Vue.directive('money',{
//   bind(el,binding,vnode){
//     let handler = function(e){      

 
//       if(e.target.value<0){
//         e.target.value = 0;
//         vnode.elm.dispatchEvent(new CustomEvent('input')); 
//         return;
//       } 
//       e.target.value = Number(e.target.value)
//      // vnode.elm.dispatchEvent(new CustomEvent('input')); 
 
//     };
//     el.addEventListener('input', handler);
//   }
//   //inserted(el,binding,vnode){},
//   //updated(el,binding,vnode){    console.log(el);  }
//   //componentUpdated(el,binding,vnode){ console.log(binding.value ); }
// });



import Vue2Filters from 'vue2-filters'
Vue.use(Vue2Filters)


import VueSlideBar from 'vue-slide-bar'
Vue.component('VueSlideBar', VueSlideBar)


import money from 'v-money'
Vue.use(money, {precision: 2})

new Vue({
  router,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount("#app");
